import { render, staticRenderFns } from "./history-today.vue?vue&type=template&id=64437774&scoped=true&"
import script from "./history-today.vue?vue&type=script&lang=js&"
export * from "./history-today.vue?vue&type=script&lang=js&"
import style0 from "./history-today.vue?vue&type=style&index=0&id=64437774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64437774",
  null
  
)

export default component.exports